import { render, staticRenderFns } from "./modalEducacionCreate.vue?vue&type=template&id=3556f7c2"
import script from "./modalEducacionCreate.vue?vue&type=script&lang=js"
export * from "./modalEducacionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports